<template>
  <page-content></page-content>
</template>

<script>
  /*edit chart component from analytics mixin*/

  // components
  import PageContent from './components/PageContent.vue';

  export default {
    name: "AnalyticsEdit",
    components: {
      PageContent
    }
  };
</script>
